import { apiSlice } from "../apiSlice";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export interface Role {
  id: string;
  displayName: string;
  roleName:string;
}

export interface CreateAdminRequest {
  displayName: string;
  email: string;
  phoneNumber: string;
  roles: Role[];
}

export interface CreateAdminResponse {
  userId: string;
  displayName: string;
  email: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  phoneNumber: string;
  roles: Role[];
}

export interface UpdateAdminRequest {
  displayName: string;
  email: string;
  phoneNumber: string;
  roles: Role[];
}

export interface UpdateAdminResponse {
  id: string;
  message: string;
  admin: {
    roles: Role[];
  };
  userId: string;
  displayName: string;
  email: string;
  phoneNumber: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
}

export interface AdminDataByIdResponse {
  admin:{
    userId: string;
    displayName: string;
    email: string;
    phoneNumber: string;
    roles: Role[];
    createdAt: {
      _seconds: number;
      _nanoseconds: number;
    };
    updatedAt?: {
      _seconds: number;
      _nanoseconds: number;
    };
  }
}

export const adminService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdmins: builder.query({
      query: () => `https://superadminhttps-getadminusers-${API_BASE_DOMAIN}-uc.a.run.app/`,
    }),
    createAdmin: builder.mutation<CreateAdminResponse, CreateAdminRequest>({
      query: (adminData) => ({
        url: `https://adminhttps-createadmin-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: adminData,
      }),
    }),
    deleteAdmin: builder.mutation({
      query: ({ id }: { id: string }) => ({
        url: `https://adminhttps-deleteAdmin-${API_BASE_DOMAIN}-uc.a.run.app/?adminId=${id}`,
        method: "DELETE",
      }),
    }),
    updateAdmin: builder.mutation<UpdateAdminResponse, { id: string; data: UpdateAdminRequest }>({
      query: ({ id, data }) => ({
        url: `https://adminhttps-updateadmin-${API_BASE_DOMAIN}-uc.a.run.app/?adminId=${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    getAdminDataById: builder.query<AdminDataByIdResponse, { id: string }>({
      query: ({ id }) => ({
        url: `https://adminhttps-getadminbyid-${API_BASE_DOMAIN}-uc.a.run.app/?adminId=${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAdminsQuery, useLazyGetAdminsQuery, useCreateAdminMutation, useDeleteAdminMutation, useUpdateAdminMutation, useGetAdminDataByIdQuery } = adminService;